// Initialize and add the map
function initMap() {
  var options = {
    zoom:6,
    center: { lat: -28.682687, lng: 24.691905},
    mapTypeControl: false,
    draggarble: false,
  }

  var map = new google.maps.Map(document.getElementById('map'), options);

  var locations = [
    //JHB
    ['ALBERTON (Express store)', -26.32740, 28.09872],
    ['ALLENS NEK RETAIL PARK (Express store)', -26.13294, 27.91440],
    ['EDENVALE', -26.14583, 28.15394],
    ['FAIRLANDS (Express store)', -26.15045, 27.94431],
    ['FOURWAYS (Express store)', -26.08102, 27.80351],
    ['LINDEN', -26.14051, 27.98614],
    ['KRUGERSDORP', -26.08788, 27.78153],
    ['MULDERSDRIFT', -26.02782, 27.87304],
    ['NEWMARKET', -26.27787, 28.12623],
    ['North Riding (Express store)', -26.03945, 27.95727],
    ['POTCHEFSTROOM', -26.71275, 27.10940],
    ['RANDBURG', -26.10303, 27.96806],
    ['ROBINDALE (Express store)', -26.11668, 27.99031],
    ['ROODEPOORT', -26.14580, 27.88113],
    ['VANDERBIJLPARK', -26.70922, 27.84571],
    ['Weltevreden Park (Express store)', -26.12507, 27.93163],
    //Pretoria
    ['CENTURION', -25.87908, 28.15984],
    ['MONTANA', -25.66490, 28.23461],
    ['Olympus (Express store)', -25.79890, 28.33301],
    //KZN
    ['BALLITO', -29.52848, 31.19772],
    ['HILLCREST', -29.77896, 30.76355],
    //Free State
    ['BLOEMFONTEIN', -29.13550, 26.20525],
    //Mpumalanga
    ['NELSPRUIT', -25.43703, 30.96781],
    //Eastern Cape
    ['PORT ELIZABETH', -33.98165, 25.59501]
  ];

  var infowindow = new google.maps.InfoWindow();

  var image = {
    url: 'https://cdn.shopify.com/s/files/1/0507/4088/7707/files/HN_location_icon_e51484cf-64e9-478c-9fdd-0535bad58746.png',
    scaledSize : new google.maps.Size(30, 42),
    origin: new google.maps.Point(0, 0),
    anchor: new google.maps.Point(0, 32)
  };

  var marker, i;

  for (i = 0; i < locations.length; i++) {  
    marker = new google.maps.Marker({
      position: new google.maps.LatLng(locations[i][1], locations[i][2]),
      icon: image,
      map: map
    });

    google.maps.event.addListener(marker, 'click', (function(marker, i) {
      return function() {
        infowindow.setContent(locations[i][0]);
        infowindow.open(map, marker);
      }
    })(marker, i));

  }
}

// Initialize and add the map
function initiateMap() {
  var options = {
    zoom:8,
    center: { lat: -26.181030, lng: 28.026856},
    mapTypeControl: false,
    draggarble: false,
    styles:[{elementType:'geometry',stylers:[{color:'#f5f5f5'}]},{elementType:'labels.icon',stylers:[{visibility:'on'}]},{elementType:'labels.text.fill',stylers:[{color:'#616161'}]},{elementType:'labels.text.stroke',stylers:[{color:'#f5f5f5'}]},{featureType:'administrative.land_parcel',elementType:'labels.text.fill',stylers:[{color:'#bdbdbd'}]},{featureType:'poi',elementType:'geometry',stylers:[{color:'#eeeeee'}]},{featureType:'poi',elementType:'labels.text.fill',stylers:[{color:'#757575'}]},{featureType:'poi.park',elementType:'geometry',stylers:[{color:'#e5e5e5'}]},{featureType:'poi.park',elementType:'labels.text.fill',stylers:[{color:'#9e9e9e'}]},{featureType:'road',elementType:'geometry',stylers:[{color:'#ffffff'}]},{featureType:'road.arterial',elementType:'labels.text.fill',stylers:[{color:'#757575'}]},{featureType:'road.highway',elementType:'geometry',stylers:[{color:'#dadada'}]},{featureType:'road.highway',elementType:'labels.text.fill',stylers:[{color:'#616161'}]},{featureType:'road.local',elementType:'labels.text.fill',stylers:[{color:'#9e9e9e'}]},{featureType:'transit.line',elementType:'geometry',stylers:[{color:'#e5e5e5'}]},{featureType:'transit.station',elementType:'geometry',stylers:[{color:'#eeeeee'}]},{featureType:'water',elementType:'geometry',stylers:[{color:'#c9c9c9'}]},{featureType:'water',elementType:'labels.text.fill',stylers:[{color:'#9e9e9e'}]}],
  }

  var map = new google.maps.Map(document.getElementById('contact_map'), options);

  var image = {
    url: 'https://cdn.shopify.com/s/files/1/0507/4088/7707/files/HN_location_icon_e51484cf-64e9-478c-9fdd-0535bad58746.png',
    scaledSize : new google.maps.Size(30, 42),
    origin: new google.maps.Point(0, 0),
    anchor: new google.maps.Point(0, 32)
  };

  var marker = new google.maps.Marker({
    position: { lat: -26.181030, lng: 28.026856 },
    map: map,
    animation: google.maps.Animation.DROP,
    icon: image,
    draggarble: false,
  });

  var information = new google.maps.InfoWindow({
    content: '<div class="marker_info"><h4 style="font-size: 20px"><strong>Health Nutrition</strong></h4><span style="color: #666">Location:</span> Johannesburg, South Africa.<br /><br />Email: <a href="mailto:info@healthnutrition.co.za" style="color: #01b2aa">info@healthnutrition.co.za</a>.<br />Phone: <a href="tel:+27614258488" style="color: #01b2aa">061 425 8488</a>.</div>'
  });

  information.open(map, marker);
}